export const PLANNED = "Planned";
export const UNPLANNED = "Unplanned";
export const UNKNOWN = "Unknown";
export const OUTSIDE_NETWORK = "OutsideNetwork";
export const REPORTED = "Reported";
